/*
 * @Author: shannyHuang
 * @Date: 2022-04-01 19:46:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-02 15:43:05
 * @FilePath: /wemeet-web-activity/src/utils/page-visibility-function.ts
 */
export const visibleLisener = (handleVisibilityChange: VoidFunction) => {
  // 兼容性
  let hidden;
  let visibilityChange = '';
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document?.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document?.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
  // 如果浏览器不支持addEventListener 或 Page Visibility API 给出警告
  if (typeof document.addEventListener === 'undefined' || !hidden) {
    console.log(
      'This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.',
    );
    return () => void 0;
  }
  console.log('hidden', hidden, 'visibilityChange', visibilityChange);
  // 处理页面可见属性的改变
  visibilityChange && document?.addEventListener(visibilityChange, handleVisibilityChange, false);
  return () => {
    visibilityChange && document?.removeEventListener(visibilityChange, handleVisibilityChange);
  };
};
